module.exports = __webpack_public_path__ + "static/media/github.4534cd67.svg";